import { getEnv } from '@ctct/ctct-helpers';

export class NavigationApi {
  /**
   * Navigate to the `/v2/pricing` page.
   *
   * Needs to be done outside of React Router, since it's on a different origin.
   */
  goToPricingPlans() {
    document.location.href = `https://www${getEnv()}constantcontact.com/pricing`;
  }

  goToVision6Signup() {
    window.open(`https://www.vision6.com.au/signup/`, '_blank');
  }

  goToSettingsBillingTab() {
    document.location.href = `https://app${getEnv()}constantcontact.com/pages/myaccount/settings/billing`;
  }

  goToSettings() {
    document.location.href = `https://app${getEnv()}constantcontact.com/pages/myaccount/settings/account`;
  }

  goToDashboard() {
    document.location.href = `https://app${getEnv()}constantcontact.com/pages/dashboard/home/`;
  }

  goToSmsSettings() {
    document.location.href = `https://app${getEnv()}constantcontact.com/pages/myaccount/settings/sms`;
  }
}

export const navigationApi = new NavigationApi();
